import './Main.css';
import './CSS/Beliefs.css';
import {beliefs} from './beList.jsx';
import {FooterLinks, HeaderLinks} from "./ToolBox.jsx"
import { Link } from 'react-router-dom';
import { useState } from 'react';


const DropDowns = () =>{
  const Collapsible = ({label, children}) => {
    const [open, setOpen] = useState(false);
    return (
      <div>
        <button type="button" className="collapsible" onClick={() => setOpen(!open)}>{label}</button>
        <div className={`content-parent ${open ? "open" : ""}`}>
          <div className="content">{children}</div>
        </div>
      </div>
    );
  };
  return(
    <div>
      <div id='griddle'>
        {beliefs.map((belief, index) => (
          <Collapsible key={index} label={belief.label}>
            <div>
            {belief.content.map((line, i) => (
              <div key={i} className="dropContent">{line.Subject && <b>{line.Subject}</b>} {line.Info}</div>
            ))}
            </div>
          </Collapsible>
        ))}
      </div>
    </div>
  );
}

export default function BeliefPage() {
  return(
    <div className="backgroundGradient">
      <Link to="/"><img src="/Images/Chapel Logo.png" alt="Pennington Chapel" /></Link>
      <HeaderLinks />
      <div className="banner">
        <h2 className="bannerText">Our Beliefs!</h2>
      </div>
      <img src="/Images/Bible.jpg" alt="Church Bible" id="bible" className="picBorder"/>
      <DropDowns />
      <FooterLinks />
    </div>
  )
}